export default function getElement($parse) {
  'ngInject';

  return {
    priority: 500,
    compile() {
      return {
        pre($scope, $element, $attrs) {
          $parse($attrs.getElement).assign($scope, $element);
        },
      };
    },
  };
}
